import React from 'react';

import { parseMarkdownLocationLink } from '@aline/common';

import { Citation } from './Citation';
import { useCitationNavigation } from './useCitationNavigation';

interface RelationshipCitationProps {
  href: string;
  referenceText: string;
  /** Carried into a cross-document jump so the destination can highlight this relationship. */
  relationshipId?: string | null;
}

/**
 * Citation component for relationship tooltips.
 * When the citation references the currently open document, scrolls to the location in-place.
 * For PDFs, highlights the referenced text on the correct page.
 * Otherwise, opens the referenced document in a new tab.
 */
export const RelationshipCitation = React.memo(function RelationshipCitation({
  href,
  referenceText,
  relationshipId,
}: RelationshipCitationProps): JSX.Element | null {
  const { getCitationTooltip, navigateToRelationshipCard } = useCitationNavigation();

  const parts = parseMarkdownLocationLink(href);
  if (!parts) return null;

  const handleClickCitation = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigateToRelationshipCard({
      citation: { href, referenceText },
      documentId: parts.documentId,
      relationshipId,
    });
  };

  return <Citation tooltip={getCitationTooltip(href)} onClickCitation={handleClickCitation} />;
});
